import { QrImageType } from 'src/containers_v2/categories/qr-images/qr-image-list/store/slice';
import IPagination from 'src/models/pagination';

export class FetchQrImagesParams implements IPagination {
  page: number;
  pageSize: number;
  search: string; // videos
  sort: string;
  expiredDate: string;
  includeProfiles: boolean;
  addedQrImageIds: string;

  constructor(
    page: number = 1,
    pageSize: number = 20,
    search: string = '',
    sort: string = 'name|asc',
    expiredDate: string = '',
    includeProfiles: boolean = false,
    addedQrImageIds: string = ""
  ) {
    this.page = page;
    this.pageSize = pageSize;
    this.search = search;
    this.sort = sort;
    this.expiredDate = expiredDate;
    this.includeProfiles = includeProfiles;
    this.addedQrImageIds = addedQrImageIds;

  }

  toString() {
    const data = [{
      param: `page=${this.page}`,
      value: this.page
    }, {
      param: `size=${this.pageSize}`,
      value: this.pageSize
    }, {
      param: `qrImageName=${this.search}`,
      value: this.search
    }, {
      param: `sort=${this.sort}`,
      value: this.sort
    }, {
      param: `expiredDate=${this.expiredDate}`,
      value: this.expiredDate
    }, {
      param: `includeProfiles=${this.includeProfiles}`,
      value: this.includeProfiles
    }, {
      param: `addedQrImageIds=${this.addedQrImageIds}`,
      value: this.addedQrImageIds
    }]

    const dataParams = data.reduce((init, item) => {
      if (!!item.value) {
        return [...init, item.param]
      }
      return [...init]
    }, [])?.join("&")

    return dataParams;
  }
}

export type QrImagesPageResult = {
  data: QrImageType[];
  totalCount: number;
};

export type QrImagesResult = {
  mirrorTypes: string[];
};
